<div class="mb-container" [formGroup]="formGroup">

   <!-- representative banding -->
      <div class="mb-card">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="field-label"> Banding</label>
            <mat-form-field class="w-100">
              <input matInput formControlName="banding" placeholder="Enter Banding" />
              <mat-icon matSuffix>percent</mat-icon>
            </mat-form-field>
            @let bandingControl = formGroup.get('banding');
            @if(bandingControl?.invalid
            && (bandingControl?.touched ||
            bandingControl?.dirty)
            ) {
            <mat-error>
              @if(bandingControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>
      </div>

  <div formArrayName="newbranch">
    <div *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i"
      class="qualification-card row g-3 align-items-end">


      <!-- Branch info + designation / supervisory structure -->
      <div class="mb-card">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="field-label">Branch Name</label>
            <mat-form-field class="w-100">
              <mat-select formControlName="branchName" placeholder="Select branch" required (selectionChange)="getdirectorsbyindex(i)">
                @for (branch of branches; track branch.branchid) {
                <mat-option [value]="branch.branchname">{{ branch.branchname }}</mat-option>
                }
              </mat-select>
              @let branchNameControl = item.get('branchName');
              @if(branchNameControl?.invalid
              && (branchNameControl?.touched ||
              branchNameControl?.dirty)
              ) {
              <mat-error>
                @if(branchNameControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }

            </mat-form-field>


          </div>

          <div class="col-md-6">
            <label class="field-label">Designation</label>
            <mat-form-field class="w-100">
              <mat-select formControlName="designation" placeholder="Select designation" required>
                @for (designation of designations; track designation) {
                <mat-option [value]="designation">{{ designation }}</mat-option>
                }

              </mat-select>
              @let designationControl = item.get('designation');
              @if(designationControl?.invalid
              && (designationControl?.touched ||
              designationControl?.dirty)
              ) {
              <mat-error>
                @if(designationControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>

          </div>

          <div class="col-md-6">
            <label class="field-label">Financial Services Director (FSD)</label>
            <mat-form-field class="w-100">
              <input formControlName="fsd" matInput placeholder="Enter fsd" readonly >
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <label class="field-label">Financial Services Manager (FSM)</label>
            <mat-form-field class="w-100">
              <mat-select formControlName="fsm" placeholder="Select"  (selectionChange)= "onManagerChange($event.value, i)" >
                <mat-option [value]="''"> </mat-option>
                @for (manager of managers[i];track manager) {
                <mat-option [value]="manager.mgr">{{ manager.mgr }}</mat-option>
                }
              </mat-select>
              @let fsmControl = item.get('fsm');
              @if(fsmControl?.invalid
              && (fsmControl?.touched ||
              fsmControl?.dirty)
              ) {
              <mat-error>
                @if(fsmControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- tier -->
          <div class="col-md-6">
            <label class="field-label"> Tier </label>

            <mat-form-field class="w-100">

              <mat-select formControlName="tier" placeholder="Select Tier">
                @for(tier of this.tierList; track tier) {
                <mat-option value="{{tier.value}}">{{tier.name}}</mat-option>
                }
              </mat-select>
              @let tierControl = item.get('tier');
              @if(tierControl?.invalid
              && (tierControl?.touched ||
              tierControl?.dirty)
              ) {
              <mat-error>
                @if(tierControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>




          <!-- Type of change -->
          <div class="col-md-6">
            <mat-label class="field-label">Type of Change</mat-label>
            <mat-form-field class="w-100 custom-form-field">
              <input matInput formControlName="type_of_change" placeholder="Enter Type of Change ">
            </mat-form-field>
            @let typeofChangeControl = item.get('type_of_change');
            @if(typeofChangeControl?.invalid
            && (typeofChangeControl?.touched ||
            typeofChangeControl?.dirty)
            ) {
            <mat-error>
              @if(typeofChangeControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>

          <!-- Remarks -->
          <div class="col-md-6">
            <mat-label class="field-label">Remarks (Optional)</mat-label>
            <mat-form-field class="w-100 custom-form-field">
              <input matInput formControlName="remarks" placeholder="Enter Remarks ">
            </mat-form-field>
            @let remarksControl = item.get('remarks');
            @if(remarksControl?.invalid
            && (remarksControl?.touched ||
            remarksControl?.dirty)
            ) {
            <mat-error>
              @if(remarksControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>

          
          <!-- Model -->
          <div class="col-md-6">
            <mat-label class="field-label">Model</mat-label>
            <mat-form-field class="w-100 custom-form-field">
              <input matInput formControlName="model" placeholder="Enter Model ">
            </mat-form-field>
            @let ModelControl = item.get('model');
            @if(ModelControl?.invalid
            && (ModelControl?.touched ||
            ModelControl?.dirty)
            ) {
            <mat-error>
              @if(ModelControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>

          <!-- effective Date -->
          <div class="col-md-6">
            <mat-label class="field-label">Effective Date</mat-label>
            <mat-form-field class="w-100">
              <input matInput [matDatepicker]="picker" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                required>
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @let effectiveDateControl = item.get('effectiveDate');
              @if(effectiveDateControl?.invalid
              && (effectiveDateControl?.touched ||
              effectiveDateControl?.dirty)
              ) {
              <mat-error>
                @if(effectiveDateControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }

            </mat-form-field>
          </div>
        </div>
      </div>

      

      <!-- Attachments -->
      <h6 class="mb-subhead"><mat-icon>attach_file</mat-icon> Attachments</h6>
      <div class="mb-card">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="field-label">Branch Documents Attachment</label>
            <label class="file-drop">
              <input id="branchDocument" type="file" hidden (change)="onFileSelected($event, 'branchDocument',i)"
                [disabled]="!isLastBranch(i) || readonly()">
              <mat-icon>upload_file</mat-icon>
              <span class="file-drop-text">{{ fileName('branchDocument',i) || 'Choose a file' }}</span>
              @if (fileName('branchDocument',i)) {
              @if(readonly() === false){
              <button type="button" class="file-clear"
                (click)="removeFile('branchDocument',i); $event.preventDefault()" [disabled]="!isLastBranch(i) || readonly()">
                <mat-icon>close</mat-icon>
              </button>
              }
              <button type="button" class="file-clear"
                (click)="previewAttachment('branchDocument',i); $event.preventDefault()">
                <mat-icon>visibility</mat-icon>
              </button>
              }
            </label>
            @let branchDocumentControl = item.get('branchDocument');
            @if((branchDocumentControl?.touched ||
            branchDocumentControl?.dirty)
            ) {
            <mat-error>
              @if(branchDocumentControl?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(branchDocumentControl?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
          <div class="col-md-6">
            <label class="field-label">Designation Documents Attachment</label>
            <label class="file-drop">
              <input id="designationDocument" type="file" accept="application/pdf,.pdf" hidden
                (change)="onFileSelected($event, 'designationDocument',i)" [disabled]="!isLastBranch(i) || readonly()">
              <mat-icon>upload_file</mat-icon>
              <span class="file-drop-text">{{ fileName('designationDocument',i) || 'Choose a file' }}</span>
              @if (fileName('designationDocument',i)) {
              @if(readonly() === false){
              <button type="button" class="file-clear"
                (click)="removeFile('designationDocument',i); $event.preventDefault()" [disabled]="!isLastBranch(i) || readonly()">
                <mat-icon>close</mat-icon>
              </button>
              }
              <button type="button" class="file-clear"
                (click)="previewAttachment('designationDocument',i); $event.preventDefault()">
                <mat-icon>visibility</mat-icon>
              </button>
              }
            </label>
            @let designationDocumentControl = item.get('designationDocument');
            @if((designationDocumentControl?.touched ||
            designationDocumentControl?.dirty)
            ) {
            <mat-error>
              @if(designationDocumentControl?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(designationDocumentControl?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>

        </div>
      </div>

      <!-- Delete -->
      <div class="col-md-3 text-end mb-3">
        @if (isLastBranch(i)) {
        @if (formArray.length > 1 && readonly() == false) {
        <button mat-stroked-button color="warn" type="button" (click)="deleteRow(i)"><mat-icon>delete</mat-icon>Delete
          branch Details</button>
        }}
      </div>
    </div>
  </div>

  @if(readonly() === false){
  <!-- Add Button -->
  <div class="text-end mt-3">
    <button class="addbranchbtn" mat-stroked-button color="primary" type="button" (click)="addRow()">
      + Add Branch
    </button>
  </div>
  }
  @if(readonly() === false){
  <!-- Form Actions -->
  @if(isvisible() === true){
  <div class="editor-actions">
    <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
    <button type="button" class="save-btn" (click)="saveSection()">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </div>
  }
  }

</div>